module.exports = __webpack_public_path__ + "img/高老庄女.9422e560.png";